export default "__VITE_ASSET__gTmiIFZH__"